import React from 'react';
import { withAppLayout } from '../core/routes';
import UsersPage from './pages/UsersPage';
import UserFormPage from './pages/UserFormPage';
import ProfilePage from './pages/ProfilePage';

export const usersRoutes = [
  { path: '/users', element: withAppLayout(<UsersPage />) },
  { path: '/users/new', element: withAppLayout(<UserFormPage />) },
  { path: '/users/:id/edit', element: withAppLayout(<UserFormPage />) },
  { path: '/profile', element: withAppLayout(<ProfilePage />) },
];
